module.exports = __webpack_public_path__ + "static/media/scr_onboarding_03_c.f7421b5f.png";